// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__Ucovi","Comment__box":"styles_Comment__box__diiJ3","Comment__boxGreen":"styles_Comment__boxGreen__z16fx"};